import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MStaticClient, MStaticInter } from '@argalis-apps/models';
import { AccountConfigService } from '../../../../services/account-config/account-config.service';

@Component({
  selector: 'argalis-apps-static-stagiare-card',
  templateUrl: './stagiare-card.component.html',
  styleUrls: ['./stagiare-card.component.scss']
})
export class StagiareCardComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  @Input('stagiareData')
  set _caData(value: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo) {
    this.stagiareData = value;
  }

  @Input('indicator')
  set _indicator(value: boolean) {
    this.indicator = value;
  }

  @Input('isInter')
  set _isInter(value: boolean) {
    this.isInter = value;
  }
  public stagiareData: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo;
  public isInter: boolean;
  public indicator: boolean;
  public headerBackground = 'uk-background-muted';
  public headerColor = 'no-style-applied';
  public bodyBackground = 'no-style-applied';
  public bodyColor = 'no-style-applied';

  constructor(private accountConfigService: AccountConfigService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }

  getParticipation(stats: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo): number {
    const nbTotal = Number((stats.dataApp || ({} as MStaticInter.IDataApp)).nbApp);
    const nbParticipants =
      nbTotal -
      Number(
        (((stats as MStaticClient.IStaticClientInfo).nbAbsent || [])[0] || ({} as MStaticClient.INbAbsent)).nb_absents
      );
    return (nbParticipants * 100 || 0) / (nbTotal || 1);
  }
}
